
export interface ListModel {
	id: number;
	todo_id: number;
	body: string;
	isCompleted: number;
	created_at: string;
	updated_at: string;
}

export interface RootObjectModel {
	id: number;
	user_id: number;
	title: string;
	description: string;
	created_at: string;
	updated_at: string;
	lists: ListModel[];
}

export const initializedListModel = {
	id: 0,
	todo_id: 0,
	body: '',
	isCompleted: 0,
	created_at: '',
	updated_at: '',
}

export const initializedRootObjectModel = {
	id: 0,
	user_id: 0,
	title: '',
	description: '',
	created_at: '',
	updated_at: '',
	lists: [initializedListModel]
}
  

